$(window).on("load", function() {
  $('.article-template__content img').each(function () {
    var currentImg = $(this);
    var currentAlt = currentImg.attr('alt');
    if (currentAlt) {
      var width = currentImg.innerWidth();
      currentImg.wrap('<div class="img-wrapper" style="width: ' + width + 'px;"></div>');
      currentImg.after('<p class="article-template__content__caption top-nav-bar">' + currentAlt + '</p>');
    }
  });
});
